export class ApiError extends Error {
  constructor(
    message: string,
    readonly code: 'authentication-required' | 'request-failed',
    readonly status?: number,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
